var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"brand-symbol",attrs:{"src":require("@/assets/img/brand/token-trend-mark.png"),"alt":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }